<div class="card mb-5" [attr.style]="(data?.colStyle || '') + (data?.rowStyle || '')" *ngIf="data">
  <div class="card-header" style="border-bottom: none; padding: 10px 12px 8px;">
    <div class="card-title d-flex flex-column">
      <h6 style="margin: 0; font-size: calc(16px * var(--dvm-font-scale, 1));" [style.text-align]="data.titleAlignment || 'center'">{{ (chartTitle || data.title) | capitalCase }}</h6>
    </div>
  </div>
  <div class="card-body" style="padding: 10px 12px 10px; position: relative;">
    <!-- Chart container: direct child div[id] so global responsive CSS + service font scaling apply -->
    <div #chartContainer [id]="data.widgetId" style="width: 100%;" [style.height]="data?.height || 'var(--dvm-chart-height, 300px)'"></div>

    <!-- Scrollbar on the right edge -->
    <div class="scrollbar-track" *ngIf="categories.length > maxVisibleCategories">
      <div class="scrollbar-thumb"
           [style.height]="getScrollbarThumbHeight() + 'px'"
           [style.top]="getScrollbarThumbTop() + 'px'"
           (mousedown)="onScrollbarMouseDown($event)"></div>
    </div>
  </div>
</div>
